import React, { type SyntheticEvent } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import messages from './messages';

type AddProps = {
	onAdd: () => void;
};

const AddView = ({ onAdd }: AddProps) => {
	const { formatMessage } = useIntl();
	return (
		<Button
			testId="servicedesk-sla-settings.ui.calendars.editable.fields.holidays.add.button"
			appearance="link"
			onClick={(e: SyntheticEvent, analyticsEvent: UIAnalyticsEvent) => {
				fireUIAnalytics(analyticsEvent, 'newAddHolidayButton');
				onAdd();
			}}
		>
			{formatMessage(messages.addNew)}
		</Button>
	);
};

export const Add = AddView;
